import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

export interface CompanyRepresentativeDialogData {
  /** Board member display name, shown for context */
  memberName: string;
  /** Current company representative text */
  value: string;
}

@Component({
  selector: 'app-company-representative-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ],
  templateUrl: './company-representative-dialog.component.html',
  styleUrls: ['./company-representative-dialog.component.scss']
})
export class CompanyRepresentativeDialogComponent {
  value: string;

  constructor(
    public dialogRef: MatDialogRef<CompanyRepresentativeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CompanyRepresentativeDialogData
  ) {
    this.value = data.value ?? '';
  }

  onSave(): void {
    this.dialogRef.close((this.value ?? '').trim());
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
